/** @format */

import {parse} from 'date-fns';

import theme from 'theme';

interface Props {
  x: number;
  y: number;
  payload: {
    value: string;
  };
}

const CustomXTick = ({payload, y, x}: Props) => {
  const value = payload.value;
  const date = parse(value, 'yyyy-MM-dd', new Date());
  const day = date.getDate();

  return (
    <>
      <line
        x1={x}
        y1={y - 7}
        x2={x}
        y2={y}
        stroke={theme.palette.figma_gray_middle_dark?.main}
        strokeWidth='1'
      />

      <text dy={13} dx={-3} fill='#FFFFFF' fontSize={10} fontWeight='400' x={x} y={y}>
        {day}
      </text>
    </>
  );
};

export {CustomXTick};
